<template>
  <div>
    <span
      v-if="data.editorTypeId == 1"
      class="studio-editor-template"
    >Studio Editor</span>
    <span
      v-if="data.editorTypeId === 2"
      class="drag-drop-editor-template"
    >Classic Drag-and-Drop</span>
    <span
      v-if="data.editorTypeId === 3"
      class="custom-code-editor-template"
    >Custom Code</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>

.studio-editor-template{
  border-radius: 32px;
  text-align: center;
  margin-right: 4px;
  position: relative;
  display: inline-block;
  background-color: #E0DFE9;
  color: #24245A;
  margin-right: 4px;
  padding: 0 1rem 0 1rem;
}

.drag-drop-editor-template{
  border-radius: 32px;
  text-align: center;
  margin-right: 4px;
  position: relative;
  display: inline-block;
  background-color: #FAEFDA;
  color: #BA841B;
  margin-right: 4px;
  padding: 0 1rem 0 1rem;
}

.custom-code-editor-template{
  border-radius: 32px;
  text-align: center;
  margin-right: 4px;
  position: relative;
  display: inline-block;
  background-color: #E9F2FA;
  color: #4484BD;
  margin-right: 4px;
  padding: 0 1rem 0 1rem;
}
</style>
